import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IOperacoesPatioGuichesMovimentacao } from "../types/types";

interface Props {
  data?: IOperacoesPatioGuichesMovimentacao;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mb-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">ID</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_patio_guiche_movimentacao
                ? props.data.id_operacao_patio_guiche_movimentacao
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Ativo
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.ativo ? "Sim" : "Não"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mb-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data de Abertura
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.abertura_data_hora
                ? formatDateTimeBR(props.data.abertura_data_hora)
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Valor do Caixa Abertura
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.abertura_valor_caixa !== undefined && props.data?.abertura_valor_caixa !== null
                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.data.abertura_valor_caixa)
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mb-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data de Fechamento
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.fechamento_data_hora
                ? formatDateTimeBR(props.data.fechamento_data_hora)
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Valor do Caixa Fechamento
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.fechamento_valor_caixa !== undefined && props.data?.fechamento_valor_caixa !== null
                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.data.fechamento_valor_caixa)
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mb-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico
                ? formatDateTimeBR(props.data.data_historico)
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
